module.exports = __webpack_public_path__ + "img/10.b79f47f4.png";